import API from '../dataApi';

// -- Users ---------------------------------------------------------------------
export const getUsers = (params) => API.get('/users', { params });
export const getUser = (id) => API.get(`/users/${id}`);
export const updateUser = (id, data) => API.put(`/users/${id}`, data);

export const updateMyName = (name) => API.put('/users/me/name', { name });
export const getDerasarMembers = (derasarId) => API.get('/users/members', { params: { derasarId } });
